import React, { useEffect, useRef, useState } from "react";

/* SSTOA 화면 머리(뒤로가기 · 제목 · 탭 · 필터)를 위에 고정한다 — 목록을 아래로 내려도 탭 버튼은 제자리 (sstoa.css .sstoa-stick).
   화면 맨 위 첫 요소로 둔다. 스크롤해서 고정되면 아래에 옅은 그림자가 생긴다. */
export default function StickyHead({ children }) {
  const ref = useRef(null);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const el = ref.current;
      setStuck(!!el && window.scrollY > 0 && el.getBoundingClientRect().top <= 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return <div ref={ref} className={`sstoa-stick${stuck ? " is-stuck" : ""}`}>{children}</div>;
}
